/* ============================================================
   AELIZA – Shopify Theme JS
   ============================================================ */

(function () {
  'use strict';

  /* ── Utility ── */
  function $(selector, context) {
    return (context || document).querySelector(selector);
  }
  function $$(selector, context) {
    return Array.from((context || document).querySelectorAll(selector));
  }

  /* ── Newsletter Popup ── */
  var NewsletterPopup = {
    popup: null,
    STORAGE_KEY: 'aeliza_newsletter_shown',

    init: function () {
      this.popup = $('#newsletter-popup');
      if (!this.popup) return;

      var closeBtn = $('#newsletter-close');
      var backdrop = $('#newsletter-backdrop');
      var triggerBtns = $$('#newsletter-trigger, #newsletter-trigger-mobile');

      // Manual triggers (SUBSCRIBE button in nav)
      triggerBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          NewsletterPopup.open();
        });
      });

      // Close on X
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          NewsletterPopup.close();
        });
      }

      // Close on backdrop click
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          NewsletterPopup.close();
        });
      }

      // Close on Escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && NewsletterPopup.popup.classList.contains('is-open')) {
          NewsletterPopup.close();
        }
      });

      // Auto-show on page load (respects section settings via data attributes)
      var showOnLoad = this.popup.dataset.showOnLoad !== 'false';
      var delay = parseInt(this.popup.dataset.delay, 10);
      if (isNaN(delay)) delay = 1200;
      var alreadyShown = sessionStorage.getItem(this.STORAGE_KEY);
      if (showOnLoad && !alreadyShown) {
        setTimeout(function () {
          NewsletterPopup.open();
          sessionStorage.setItem(NewsletterPopup.STORAGE_KEY, '1');
        }, delay);
      }
    },

    open: function () {
      if (!this.popup) return;
      this.popup.classList.add('is-open');
      this.popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.popup) return;
      this.popup.classList.remove('is-open');
      this.popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  /* ── Cart Drawer ── */
  var CartDrawer = {
    drawer: null,
    overlay: null,

    init: function () {
      this.drawer = $('#cart-drawer');
      this.overlay = $('#cart-overlay');
      if (!this.drawer) return;

      var triggers = $$('#cart-trigger, #cart-trigger-mobile');
      var closeBtn = $('#cart-close');

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          CartDrawer.open();
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          CartDrawer.close();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', function () {
          CartDrawer.close();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && CartDrawer.drawer.classList.contains('is-open')) {
          CartDrawer.close();
        }
      });

      // Quantity change & remove buttons
      this.drawer.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('.qty-btn');
        var removeBtn = e.target.closest('.cart-item__remove');

        if (qtyBtn) {
          var line = parseInt(qtyBtn.dataset.line, 10);
          var action = qtyBtn.dataset.action;
          CartDrawer.updateQty(line, action);
        }

        if (removeBtn) {
          var line = parseInt(removeBtn.dataset.line, 10);
          CartDrawer.removeLine(line);
        }
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    updateQty: function (line, action) {
      var items = $$('.cart-item');
      if (!items[line - 1]) return;

      var qtySpan = items[line - 1].querySelector('.cart-item__qty span');
      var currentQty = parseInt(qtySpan ? qtySpan.textContent : '1', 10);
      var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          CartDrawer.updateCount(cart.item_count);
          if (newQty === 0) {
            items[line - 1].remove();
          } else if (qtySpan) {
            qtySpan.textContent = newQty;
          }
          CartDrawer.updateSubtotal(cart.total_price);
          if (cart.item_count === 0) CartDrawer.showEmpty();
        })
        .catch(function (err) { console.error('Cart update error:', err); });
    },

    removeLine: function (line) {
      CartDrawer.updateQty(line, 'remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          CartDrawer.updateCount(cart.item_count);
          CartDrawer.updateSubtotal(cart.total_price);
          if (cart.item_count === 0) CartDrawer.showEmpty();
          else {
            var items = $$('.cart-item');
            if (items[line - 1]) items[line - 1].remove();
          }
        });
    },

    updateCount: function (count) {
      $$('#cart-count, #cart-count-mobile').forEach(function (el) {
        el.textContent = count;
      });
    },

    updateSubtotal: function (totalCents) {
      var el = $('#cart-subtotal');
      if (el) el.textContent = CartDrawer.formatMoney(totalCents);
    },

    showEmpty: function () {
      var body = $('#cart-drawer-body');
      if (body) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      }
    },

    renderItems: function (cart) {
      var body = $('#cart-drawer-body');
      if (!body) return;
      if (cart.item_count === 0) {
        CartDrawer.showEmpty();
        return;
      }
      var html = '';
      cart.items.forEach(function (item, i) {
        var lineNum = i + 1;
        html += '<div class="cart-item">';
        if (item.image) {
          html += '<div class="cart-item__image"><img src="' + item.image + '" alt="' + item.product_title + '" width="60" height="auto" loading="lazy"></div>';
        }
        html += '<div class="cart-item__info">';
        html += '<p class="cart-item__title">' + item.product_title.toUpperCase() + '</p>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<p class="cart-item__variant">' + item.variant_title + '</p>';
        }
        html += '<p class="cart-item__price">' + CartDrawer.formatMoney(item.final_price) + '</p>';
        html += '<div class="cart-item__qty">';
        html += '<button class="qty-btn" data-action="decrease" data-line="' + lineNum + '">–</button>';
        html += '<span>' + item.quantity + '</span>';
        html += '<button class="qty-btn" data-action="increase" data-line="' + lineNum + '">+</button>';
        html += '</div></div>';
        html += '<button class="cart-item__remove" data-line="' + lineNum + '" aria-label="Remove">✕</button>';
        html += '</div>';
      });
      html += '<div class="cart-drawer__footer">';
      html += '<div class="cart-drawer__subtotal"><span>SUBTOTAL</span><span id="cart-subtotal">' + CartDrawer.formatMoney(cart.total_price) + '</span></div>';
      html += '<a href="/checkout" class="btn btn--full">CHECKOUT</a>';
      html += '</div>';
      body.innerHTML = html;
    },

    formatMoney: function (cents) {
      return '£' + (cents / 100).toFixed(2);
    }
  };

  /* ── Add to Cart ── */
  var ProductForm = {
    init: function () {
      var form = $('#product-form');
      if (!form) return;

      // Variant selection via radio buttons
      $$('.product-option__value input').forEach(function (input) {
        input.addEventListener('change', function () {
          ProductForm.updateSelectedVariant();
        });
      });

      // Gallery thumbnails
      $$('.product-gallery__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = parseInt(thumb.dataset.index, 10);
          ProductForm.showSlide(index);
        });
      });

      // Add to cart submission
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        ProductForm.addToCart(form);
      });
    },

    updateSelectedVariant: function () {
      var select = $('#product-select');
      if (!select) return;

      // Build the selected option values
      var selectedValues = [];
      $$('.product-option__values').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) selectedValues.push(checked.value);

        // Update visual selected state
        group.querySelectorAll('.product-option__value').forEach(function (label) {
          label.classList.remove('product-option__value--selected');
        });
        if (checked) {
          checked.closest('.product-option__value').classList.add('product-option__value--selected');
        }
      });

      // Find matching variant
      var options = Array.from(select.options);
      var match = options.find(function (opt) {
        return opt.dataset.available !== 'false';
      });

      // Try to find exact match by title
      var title = selectedValues.join(' / ');
      var exact = options.find(function (opt) {
        return opt.text.trim() === title;
      });
      if (exact) {
        select.value = exact.value;
        var variantId = $('#variant-id');
        if (variantId) variantId.value = exact.value;

        var price = parseInt(exact.dataset.price || '0', 10);
        var priceEl = $('#product-price');
        if (priceEl) priceEl.innerHTML = '<span>£' + (price / 100).toFixed(2) + '</span>';

        var addBtn = $('#add-to-cart');
        var available = exact.dataset.available !== 'false';
        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
        }
      }
    },

    showSlide: function (index) {
      $$('.product-gallery__slide').forEach(function (slide, i) {
        slide.classList.toggle('product-gallery__slide--active', i === index);
      });
      $$('.product-gallery__thumb').forEach(function (thumb, i) {
        thumb.classList.toggle('product-gallery__thumb--active', i === index);
      });
    },

    addToCart: function (form) {
      var btn = $('#add-to-cart');
      var originalText = btn ? btn.textContent : 'ADD TO CART';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'ADDING...';
      }

      var variantId = $('#variant-id');
      var id = variantId ? variantId.value : '';
      var productTitle = ($('.product-main__title') || {}).textContent || '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          CartDrawer.updateCount(cart.item_count);
          CartDrawer.renderItems(cart);
          if (btn) {
            btn.textContent = 'ADDED ✓';
            btn.disabled = false;
            setTimeout(function () { btn.textContent = originalText; }, 2000);
          }
          ProductForm.showNotification(productTitle);
          CartDrawer.open();
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          if (btn) {
            btn.disabled = false;
            btn.textContent = originalText;
          }
        });
    },

    showNotification: function (title) {
      var existing = $('.cart-notification');
      if (existing) existing.remove();
      var el = document.createElement('div');
      el.className = 'cart-notification';
      el.innerHTML = '"' + title + '" ADDED TO CART &nbsp;·&nbsp; <a href="/cart">VIEW CART</a>';
      document.body.appendChild(el);
      requestAnimationFrame(function () {
        el.classList.add('is-visible');
      });
      setTimeout(function () {
        el.classList.remove('is-visible');
        setTimeout(function () { el.remove(); }, 300);
      }, 3500);
    }
  };

  /* ── Product Gallery — mobile touch swipe ── */
  var ProductGallery = {
    init: function () {
      var gallery = $('.product-main__gallery');
      if (!gallery) return;
      var track = $('.product-gallery__track', gallery);
      if (!track) return;

      // Only activate swipe when layout is in mobile carousel mode
      // (CSS switches flex-direction to row at ≤900px)
      var checkAndBind = function () {
        if (window.innerWidth > 900) return; // desktop: stacked, no swipe needed
        var slides = Array.from(track.children);
        if (slides.length <= 1) return;

        var dotsContainer = $('.product-gallery__dots', gallery);
        var currentIndex = 0;
        var startX = 0;
        var startY = 0;

        // Build dot indicators
        if (dotsContainer && dotsContainer.children.length === 0) {
          slides.forEach(function (_, i) {
            var dot = document.createElement('button');
            dot.className = 'product-gallery__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
            dot.addEventListener('click', function () { goTo(i); });
            dotsContainer.appendChild(dot);
          });
        }

        function goTo(index) {
          currentIndex = Math.max(0, Math.min(index, slides.length - 1));
          track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
          if (dotsContainer) {
            $$('.product-gallery__dot', dotsContainer).forEach(function (dot, i) {
              dot.classList.toggle('is-active', i === currentIndex);
            });
          }
        }

        // Touch events
        track.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });

        track.addEventListener('touchend', function (e) {
          var dx = startX - e.changedTouches[0].clientX;
          var dy = startY - e.changedTouches[0].clientY;
          // Only treat as horizontal swipe if dx dominates dy
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
            goTo(dx > 0 ? currentIndex + 1 : currentIndex - 1);
          }
        }, { passive: true });
      };

      // Run on init and whenever viewport crosses 900px
      checkAndBind();
      window.addEventListener('resize', function () {
        // Reset track on resize to avoid stale transforms
        if (window.innerWidth > 900) {
          track.style.transform = '';
        }
      });
    }
  };

  /* ── Mobile Nav ── */
  var MobileNav = {
    init: function () {
      var toggle = $('#mobile-menu-toggle');
      var nav = $('#mobile-nav');
      if (!toggle || !nav) return;

      toggle.addEventListener('click', function () {
        var isOpen = nav.classList.toggle('is-open');
        toggle.classList.toggle('is-active', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        nav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      });

      // Children toggles
      $$('.mobile-nav__toggle-children').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var children = btn.nextElementSibling;
          if (!children) return;
          var isOpen = children.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          children.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });
      });
    }
  };

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    NewsletterPopup.init();
    CartDrawer.init();
    ProductForm.init();
    ProductGallery.init();
    MobileNav.init();
  });

})();
